/**
 * Flat list of steps across every admin page, in walkthrough order. Each step's
 * `page` is the route it belongs to — AdminTour navigates there automatically
 * when Next/Back crosses a page boundary, so the tour reads as one continuous
 * walkthrough instead of resetting each time you land on a new admin page.
 */
const tourSteps = [
  {
    page: '/admin/rules',
    target: 'settings-tabs',
    title: 'Game Settings',
    description:
      'Everything about how the game looks and runs: game mode, colours, intro text, feedback messages, the completion screen and live voting time.',
  },
  {
    page: '/admin/rules',
    target: 'settings-save',
    title: 'Save as draft',
    description: 'Saving keeps your changes as a draft — players keep seeing the published version until you press Publish.',
  },
  {
    page: '/admin/themeupdate',
    target: 'tour-gc-quiz',
    title: 'Crossroads',
    description:
      'Each crossroads is one decision: a scenario, two coloured roads (with a correct answer, or choice based with no right answer), a “Did You Know?” moment and points. Reorder them with the arrows, or upload many at once from a CSV (download the Sample CSV for the format).',
  },
  {
    page: '/admin/themeupdate',
    target: 'admin-live',
    title: 'Run a live game',
    description:
      'For Live Audience mode: players join from their normal game link and wait. From Live Control you start the game, release each crossroads, close voting, reveal the answer and move on — players see every step instantly.',
  },
  {
    page: '/admin/themeupdate',
    target: 'admin-publish',
    title: 'Publish',
    description: 'When the draft looks right, publish it so players get the latest version. The status next to it tells you if there are unpublished changes.',
  },
  {
    page: '/admin/reports',
    target: 'reports-metrics',
    title: 'Reports',
    description: 'Participation, scores, accuracy and the most-chosen path for every crossroads — plus live voting results. Export any table to CSV.',
  },
];

export default tourSteps;
